import { types } from 'mobx-state-tree'
import { Address, addressData, addressData1, addressData11, addressData12, addressData2, addressData8 } from './Address'

const Bank = types.model('Bank', {
  id: types.string,
  ifsc: types.string,
  branch: types.string,
  name: types.string,
  address: Address,
})

const bankData = Bank.create({
  id: '1',
  ifsc: 'JIO00000001',
  branch: 'RPC',
  name: 'Jio Payments Bank',
  address: addressData,
})

const bankData1 = Bank.create({
  id: '2',
  ifsc: 'JIO00000002',
  branch: 'Bandra',
  name: 'Jio Payments Bank',
  address: addressData1,
})

const bankData2 = Bank.create({
  id: '3',
  ifsc: 'JIO00000003',
  branch: 'CST Terminal',
  name: 'Jio Payments Bank',
  address: addressData2,
})

const bankData3 = Bank.create({
  id: '4',
  ifsc: 'JIO00000004',
  branch: 'Pune road',
  name: 'Jio Payments Bank',
  address: addressData8,
})

const bankData4 = Bank.create({
  id: '5',
  ifsc: 'JIO00000004',
  branch: 'Pune road',
  name: 'Jio Payments Bank',
  address: addressData11,
})

const bankData5 = Bank.create({
  id: '6',
  ifsc: 'JIO00000004',
  branch: 'Pune road',
  name: 'Jio Payments Bank',
  address: addressData12,
})

export { Bank, bankData, bankData1, bankData2, bankData3, bankData4, bankData5 }
